'use strict';

var internals = {};

module.exports = internals.flatten = function (array, target) {
  var result = target || [];

  for (var i = 0; i < array.length; ++i) {
    if (Array.isArray(array[i])) {
      internals.flatten(array[i], result);
    } else {
      result.push(array[i]);
    }
  }

  return result;
};